import { writable } from "svelte/store";

/**
 *
 *
 */
export const sizePreferencesUpdateTrigger = writable(0);

/**
 *
 */
export function triggerSizePreferencesUpdate() {
  sizePreferencesUpdateTrigger.update((n) => n + 1);
}
